import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRequestQuestionImage } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'images-msg',
  templateUrl: './images-msg.component.html',
  styleUrls: ['./images-msg.component.scss']
})
export class ImagesMsgComponent implements OnInit {
  @Input() questionTitle: string;
  @Input() images: IRequestQuestionImage[];

  @Output() onShowImage = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

}
